import { render, staticRenderFns } from "./LocationVerification.vue?vue&type=template&id=085bb6c1"
import script from "./LocationVerification.vue?vue&type=script&lang=js"
export * from "./LocationVerification.vue?vue&type=script&lang=js"
import style0 from "./LocationVerification.vue?vue&type=style&index=0&id=085bb6c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports